import * as r from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/WarningCircle.es.js";
const e = r.forwardRef((o, n) => /* @__PURE__ */ r.createElement(a, { ref: n, ...o, weights: i }));
e.displayName = "WarningCircleIcon";
const m = e;
export {
  m as WarningCircle,
  e as WarningCircleIcon
};
